import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [academicsOpen, setAcademicsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const getPath = (item) => {
    if (item === 'Home') return '/';
    if (item === 'About Us') return '/about';
    if (item === 'Contact Us') return '/contact';
    if (item === 'Social Media') return '/social-media';
    if (item === 'News & Events') return '/news-events';
    return `/${item.toLowerCase()}`;
  };

  return (
    <nav style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      background: scrolled ? 'rgba(255, 255, 255, 0.98)' : 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
      backdropFilter: scrolled ? 'blur(10px)' : 'none',
      boxShadow: scrolled ? '0 4px 20px rgba(0,0,0,0.1)' : '0 2px 10px rgba(0,0,0,0.05)',
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      padding: scrolled ? '15px 0' : '20px 0',
      willChange: 'transform, opacity'
    }}>
      <div className="container" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '20px'}}>
        <div style={{display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap', justifyContent: 'center'}}>
          <img src="/images/logo.svg" alt="Bethel Public School Logo" style={{height: scrolled ? '70px' : '80px', transition: 'height 0.3s cubic-bezier(0.4, 0, 0.2, 1)', willChange: 'height', maxWidth: '100%'}} />
          <div style={{display: 'flex', flexDirection: 'column', gap: '5px'}}>
            <span style={{fontSize: scrolled ? 'clamp(1.2rem, 4vw, 1.6rem)' : 'clamp(1.3rem, 4vw, 1.8rem)', fontWeight: 700, color: '#0f172a', transition: 'font-size 0.3s cubic-bezier(0.4, 0, 0.2, 1)', letterSpacing: '0.5px', fontFamily: 'Georgia, serif', willChange: 'font-size', textAlign: 'center'}}>Bethel Public School</span>
            <span style={{fontSize: 'clamp(0.8rem, 2.5vw, 1rem)', color: '#475569', fontWeight: 600, textAlign: 'center'}}>
              <i className="fas fa-trophy" style={{marginRight: '5px', color: '#f59e0b'}}></i>
              22+ Years of Excellence of Education
            </span>
          </div>
        </div>
        
        {/* Hamburger Menu Button */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          style={{
            display: window.innerWidth <= 768 ? 'block' : 'none',
            background: 'none',
            border: 'none',
            fontSize: '1.8rem',
            color: '#1e293b',
            cursor: 'pointer',
            padding: '10px'
          }}
        >
          <i className={mobileMenuOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
        </button>

        <ul style={{
          display: window.innerWidth <= 768 ? (mobileMenuOpen ? 'flex' : 'none') : 'flex',
          flexDirection: window.innerWidth <= 768 ? 'column' : 'row',
          gap: '5px',
          listStyle: 'none',
          margin: 0,
          padding: 0,
          alignItems: 'center',
          flexWrap: 'wrap',
          justifyContent: 'center',
          width: window.innerWidth <= 768 ? '100%' : 'auto',
          background: window.innerWidth <= 768 ? 'white' : 'transparent',
          borderRadius: window.innerWidth <= 768 ? '10px' : '0',
          boxShadow: window.innerWidth <= 768 ? '0 4px 10px rgba(0,0,0,0.1)' : 'none',
          padding: window.innerWidth <= 768 ? '10px' : '0',
          maxHeight: window.innerWidth <= 768 ? '70vh' : 'auto',
          overflowY: window.innerWidth <= 768 ? 'auto' : 'visible'
        }}>
          {['Home', 'About Us'].map((item, i) => (
            <li key={i}>
              <NavLink 
                to={getPath(item)}
                onClick={() => {window.scrollTo(0, 0); setMobileMenuOpen(false);}}
                style={({isActive}) => ({
                  color: isActive ? '#f59e0b' : '#1e293b',
                  textDecoration: 'none',
                  padding: '12px 20px',
                  borderRadius: '12px',
                  fontWeight: 700,
                  fontSize: '1.05rem',
                  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                  background: isActive ? 'rgba(0, 0, 0, 0.05)' : 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  display: 'inline-block',
                  transform: 'scale(1)',
                  fontFamily: 'Inter, sans-serif'
                })}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(0, 0, 0, 0.05)';
                  e.currentTarget.style.transform = 'scale(1.05)';
                }}
                onMouseLeave={(e) => {
                  if (!e.currentTarget.classList.contains('active')) {
                    e.currentTarget.style.background = 'transparent';
                  }
                  e.currentTarget.style.transform = 'scale(1)';
                }}
              >
                {item}
              </NavLink>
            </li>
          ))}
          <li style={{position: 'relative'}}
            onMouseEnter={() => setAcademicsOpen(true)}
            onMouseLeave={() => setAcademicsOpen(false)}>
            <NavLink 
              to="/academics"
              onClick={() => {window.scrollTo(0, 0); setMobileMenuOpen(false);}}
              style={({isActive}) => ({
                color: isActive ? '#f59e0b' : '#1e293b',
                textDecoration: 'none',
                padding: '12px 20px',
                borderRadius: '12px',
                fontWeight: 700,
                fontSize: '1.05rem',
                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                background: isActive ? 'rgba(0, 0, 0, 0.05)' : 'transparent',
                border: 'none',
                cursor: 'pointer',
                display: 'inline-block',
                transform: 'scale(1)',
                fontFamily: 'Inter, sans-serif'
              })}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(0, 0, 0, 0.05)';
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                if (!e.currentTarget.classList.contains('active')) {
                  e.currentTarget.style.background = 'transparent';
                }
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              Academics <i className="fas fa-chevron-down" style={{fontSize: '0.8rem', marginLeft: '5px'}}></i>
            </NavLink>
            {academicsOpen && (
              <div style={{
                position: 'absolute',
                top: 'calc(100% - 5px)',
                left: 0,
                background: 'white',
                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                borderRadius: '12px',
                paddingTop: '10px',
                minWidth: '200px',
                padding: '10px 0',
                zIndex: 1001
              }}>
                <NavLink
                  to="/school-leader"
                  onClick={() => {window.scrollTo(0, 0); setMobileMenuOpen(false);}}
                  style={{
                    display: 'block',
                    padding: '12px 20px',
                    color: '#1e293b',
                    textDecoration: 'none',
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 600,
                    fontSize: '1rem',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'rgba(0, 0, 0, 0.05)';
                    e.currentTarget.style.color = '#f59e0b';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = '#1e293b';
                  }}
                >
                  School Cabinet
                </NavLink>
              </div>
            )}
          </li>
          {['Facilities', 'Gallery', 'Social Media', 'News & Events', 'Contact Us'].map((item, i) => (
            <li key={i}>
              <NavLink 
                to={getPath(item)}
                onClick={() => {window.scrollTo(0, 0); setMobileMenuOpen(false);}}
                style={({isActive}) => ({
                  color: isActive ? '#f59e0b' : '#1e293b',
                  textDecoration: 'none',
                  padding: '12px 20px',
                  borderRadius: '12px',
                  fontWeight: 700,
                  fontSize: '1.05rem',
                  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                  background: isActive ? 'rgba(0, 0, 0, 0.05)' : 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  display: 'inline-block',
                  transform: 'scale(1)',
                  fontFamily: 'Inter, sans-serif'
                })}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(0, 0, 0, 0.05)';
                  e.currentTarget.style.transform = 'scale(1.05)';
                }}
                onMouseLeave={(e) => {
                  if (!e.currentTarget.classList.contains('active')) {
                    e.currentTarget.style.background = 'transparent';
                  }
                  e.currentTarget.style.transform = 'scale(1)';
                }}
              >
                {item}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
